import React, { useState } from 'react';
import './Treatments.css';
import waveMobile from '../../../../images/lp/googleV2/treatmentareaswave_mweb.svg';
import waveDesktop from '../../../../images/lp/googleV2/treatmentareaswave_desktop.svg';
import treatmentsData from './treatmentdata';

function TreatmentSelection({ items, selected, onSelect }) {
    return (
        <ul className="googlelp-treatment-selection mcl-font-proxima mb-4 mb-md-0" role="tablist">
            {items.map((it) => (
                <li key={it.id}>
                    <button
                        className={`treatment-select-button py-0 px-3 ${selected === it.id ? 'active' : ''}`}
                        onClick={() => onSelect(it.id)}
                        role="tab"
                        aria-selected={selected === it.id}
                    >
                        {it.title}
                    </button>
                </li>
            ))}
        </ul>
    );
}

function TreatmentDetail({ item }) {
    if (!item) return null;
    return (
        <div className="googlelp-treatment-detail p-3 p-md-4">
            <div className="googlelp-treatment-images">
                <figure className={`before mb-0 ${!item.after ? 'single-img' : ''}`}>
                    <img src={item.before} alt={`${item.title} before`} />
                    {item.showBeforeAfter && <figcaption className="label mcl-font-proxima">Before</figcaption>}
                </figure>
                {item.after && (
                    <figure className="after mb-0">
                        <img src={item.after} alt={`${item.title} after`} />
                        {item.showBeforeAfter && <figcaption className="label mcl-font-proxima">After</figcaption>}
                    </figure>
                )}
            </div>
            <div className="googlelp-treatment-meta">
                <h3 className="treatment-title mt-4 mb-2 mt-md-0 mcl-font-proxima">{item.title}</h3>
                <p className="treatment-desc mcl-font-proxima">{item.desc}</p>
                <a href="#googlelp-quote" className="rounded-pill primary-btn button-cta-dark mb-2">
                    Get started
                </a>
            </div>
        </div>
    );
}

export function Treatments() {
    const [selectedTreatment, setSelectedTreatment] = useState(treatmentsData[0].id);

    const selectedItem = treatmentsData.find((t) => t.id === selectedTreatment);

    return (
        <>
            <img src={waveDesktop} alt="Wave" className="d-none d-md-block googlelp-wave-desktop" />
            <img src={waveMobile} alt="Wave" className="d-md-none googlelp-wave-mweb" />
            <section className="googlelp-treatments flex flex-column text-center">
                <div className="googlelp-treatments googlelp-container flex flex-column text-center">
                    <h2 className="mcl-font-greycliff mb-0">Treatment areas</h2>
                    <p className="googlelp-treatments-subheader mcl-font-proxima mb-0 pt-2 pb-4 pb-md-5">
                        From underarms to full body, target the areas that matter most to you.
                    </p>
                </div>

                <div className="googlelp-treatments-grid py-0 px-4 pb-md-5">
                    <TreatmentSelection
                        items={treatmentsData}
                        selected={selectedTreatment}
                        onSelect={setSelectedTreatment}
                    />
                </div>
                <div className="googlelp-container">
                    <TreatmentDetail item={selectedItem} onAction={() => setSelectedTreatment(selectedItem.id)} />
                </div>
                <div className="googlelp-container text-center">
                    <p className="googlelp-treatments-note mcl-font-proxima">
                        Most clients see permanent results in just{' '}
                        <strong>
                            <br className="break" />
                            7-10 sessions
                        </strong>
                    </p>
                </div>
            </section>
        </>
    );
}

export default Treatments;
